import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SettingsComponent } from "./settings.component";
import { AuthGuard } from "../../../shared";

const routes: Routes = [
  {
    path: "", // path is "settings"
    component: SettingsComponent,
    canActivate: [AuthGuard],
    data: {
      title: "Settings  Page",
      icon: "ti-layout-sidebar-left",
      caption: "You chan change your profile and account settings here",
      status: true,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SettingsRoutingModule {}
